/* global Metafans_JS */
import { visibilityPostFormData } from './templates.js';
import { activityVisibilityMarkup } from './ui.js';

const visibilityData = [
    {
        id: 1,
        vi: "public",
        content: `<span class="ac-vi-co" data-vi="1">
            <span class="ac_vi_text"> Public </span>
            ${visibilityPostFormData.find((cur) => cur.vi == 'public').svg}
        </span>`,
    },
    {
        id: 2,
        vi: "friends",
        content: `<span class="ac-vi-co" data-vi="2">
            <span class="ac_vi_text"> Friends </span>
            ${visibilityPostFormData.find((cur) => cur.vi == 'friends').svg}
        </span>`,
    },
    {
        id: 3,
        vi: "onlyme",
        content: `<span class="ac-vi-co" data-vi="3">
            <span class="ac_vi_text">Only me </span>
            ${visibilityPostFormData.find((cur) => cur.vi == 'onlyme').svg}
        </span>`,
    },
];

/**
 * Updates activity visibility via AJAX.
 * @param {number} acId - The activity ID.
 * @param {string} visiType - The new visibility type.
 */
function updateVisibility(acId, visiType) {
    jQuery.ajax({
        url: Metafans_JS.ajaxurl,
        type: "post",
        data: {
            action: "th_bp_update_activity_visibility",
            activity_id: acId,
            activity_accessibility: visiType,
        },
        success: function (response) {
            console.log(response);
        },
    });
}

/**
 * Changes the visibility icon on the activity item.
 * @param {HTMLElement} eventTarget - The element that was clicked.
 * @param {number} iconIn - The index of the new icon in visibilityData.
 */
function changeVisibilityIcon(eventTarget, iconIn) {
    const parentDom = eventTarget.parentElement;
    eventTarget.remove();
    parentDom.insertAdjacentHTML("beforeend", visibilityData[iconIn].content);
}

/**
 * Closes the edit visibility popup.
 */
function closeEditeVisibilityPopup() {
    const acPop = document.querySelector(".ac-vi-pop");
    if (acPop) {
        acPop.remove();
    }
}

/**
 * Sets the active state on a visibility option in the popup.
 * @param {number} elIn - The index of the element to activate.
 */
function activeVisibility(elIn) {
    const options = document.querySelector(".ac-vi-options")?.children;
    if (!options || !options.length) return;
    Array.from(options).forEach((cur) => cur.classList.remove("ac-vi-active"));
    options[elIn].classList.add("ac-vi-active");
}

/**
 * Sets up event listeners for the visibility selection popup.
 * @param {HTMLElement} eventTarget - The original icon element that was clicked.
 * @param {number} acId - The activity ID.
 */
function selectVisibilityHandeler(eventTarget, acId) {
    const acPop = document.querySelector(".ac-vi-pop");
    if (!acPop) return;

    const options = acPop.querySelector(".ac-vi-options").children;

    Array.from(options).forEach((cur, i) => {
        cur.addEventListener("click", () => {
            activeVisibility(i);
            changeVisibilityIcon(eventTarget, i);
            updateVisibility(parseInt(acId), visibilityData[i].vi);
            closeEditeVisibilityPopup();
        });
    });

    acPop.querySelector(".close-ac-vi-popup")?.addEventListener("click", closeEditeVisibilityPopup);
    acPop.querySelector(".visibility-back")?.addEventListener("click", closeEditeVisibilityPopup);
}

/**
 * Opens the edit visibility popup.
 * @param {HTMLElement} eventTarget - The icon element that was clicked.
 * @param {number} acId - The activity ID.
 */
function openEditeVisibilityPopup(eventTarget, acId) {
    closeEditeVisibilityPopup(); // Close any previous popup
    document.querySelector("body").insertAdjacentHTML("afterbegin", activityVisibilityMarkup());
    selectVisibilityHandeler(eventTarget, acId);
}

/**
 * Initializes the event listener for the activity stream to handle visibility icon clicks.
 */
export function init() {
    const activityCon = document.getElementById("activity-stream");
    if (!activityCon) return;

    activityCon.addEventListener("click", (e) => {
        const visibilityIcon = e.target.closest(".ac-vi-co");
        if (!visibilityIcon) return;
        e.preventDefault();
        // Per request, skip opening the visibility popup on posted cards.
        return;

        const acItemDom = visibilityIcon.closest(".activity-item");
        const hasPermision = acItemDom?.dataset.canedite;
        const acId = acItemDom?.dataset.bpActivityId;

        if (hasPermision !== "true" || !acId) return;

        openEditeVisibilityPopup(visibilityIcon, parseInt(acId));

        const acviId = visibilityIcon.dataset.vi;
        if (acviId) {
            activeVisibility(parseInt(acviId) - 1);
        }
    });
}